import {
  GenerateSharedLinkBody,
  NewsItemDetailsType,
  SharedLinkDetailsData,
} from '../../../interfaces/api/tabs';
import {services} from '../../../api';
import {
  finishLoading,
  startLoading,
} from '../../../connected-components/loading/actions';

/**
 * this function to get News Details list
 *
 * @return {NewsItemDetailsType | null} news details
 */
export const getNewsDetails = async (
  id: number,
  isRecommendation?: boolean,
): Promise<NewsItemDetailsType | null> => {
  try {
    const res = await services.news.getNewsDetails(id, isRecommendation);
    return res?.content || {};
  } catch (error: any) {
    return null;
  }
};

/**
 * this function to generate shared News link
 *
 * @return {string | null} shared link to news detail
 */
export const generateShareLink = async (
  body: GenerateSharedLinkBody,
): Promise<string | null> => {
  try {
    startLoading();
    const res = await services.news.generateSharedLink(body);
    return res?.content?.token;
  } catch (error: any) {
    return null;
  } finally {
    finishLoading();
  }
};

/**
 * this function to get Share Link News Details
 *
 * @return {SharedLinkDetailsData | null} shared link news detail date
 */
export const getShareLinkNewsDetails = async (
  token: string,
): Promise<SharedLinkDetailsData | null> => {
  try {
    startLoading();
    const res = await services.news.getSharedLinkDetails(token);
    return res?.content;
  } catch (error: any) {
    return null;
  } finally {
    finishLoading();
  }
};
